import loadable from "@loadable/component";
import CreateIcon from "../../Icons/CreateIcon";
import { useParams } from "react-router-dom";
import APIS from "../../constant/Endpoint";
import useGetHook from "../../customHooks/useGetHook";
import usePatchHook from "../../customHooks/usePatchHook";
import Spinner from "../../components/Reusable/Spinner";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const EditMerchantInvoiceComponent = loadable(
  () => import("../../components/MerchantInvoice/EditMerchantInvoice")
);

const EditMerchantInvoice = () => {
  const { id } = useParams();
  const { data, isLoading } = useGetHook({
    queryKey: [`merchant-invoice-${id}`],
    url: `${APIS.MERCHANT_INVOICE}${id}/`,
    params: {},
  });

  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: ["merchant-invoice", `merchant-invoice-${id}`],
    navigateURL: "/",
  });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.BRANCH_INVOICE}${id}/`;
    let formData = {};
    console.log(formData, "handle edit");
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Edit Merchant Statment
        </span>
      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        <EditMerchantInvoiceComponent
          isLoading={isPatchLoading}
          handleEdit={handleEdit}
          data={data}
        />
      )}
    </>
  );
};

export default EditMerchantInvoice;
